import firebase from "config/firebase";
import { toast } from "react-toastify";

export const createSportsCommunityBadge =
  (payload, onSuccess = () => {}) =>
  async () => {
    try {
      firebase
        .firestore()
        .collection("sports_community_badges")
        .add({ ...payload });

      toast.success("Payment SuccessFully");
      onSuccess();
    } catch (error) {
      console.error("Error creating sports community badge: ", error);
      toast.error("Error creating sports community badge: ", error);
    }
  };

export const getSportsCommunityBadge =
  (userID, onSuccess = () => {}) =>
  (dispatch) => {
    return firebase
      .firestore()
      .collection("sports_community_badges")
      .where("userID", "==", userID)
      .orderBy("createdAt", "desc")
      .onSnapshot(
        (querySnapshot) => {
          const badgeData = [];

          querySnapshot.forEach((doc) => {
            badgeData.push({ id: doc.id, ...doc.data() });
          });

          dispatch({
            type: "SET_SPORTS_COMMUNITY_BADGE",
            payload: badgeData,
          });

          onSuccess(badgeData);
        },
        (error) => {
          console.error("Error in real-time badge listener:", error);
        }
      );
  };

export const getLastSportsCommunityBadge = () => (dispatch) => {
  firebase
    .firestore()
    .collection("sports_community_badges")
    .orderBy("createdAt", "desc")
    .limit(1)
    .get()
    .then((snapshot) => {
      const doc = snapshot.docs[0];
      const badgeData = { ...doc.data() };
      dispatch({
        type: "SET_LAST_SPORTS_COMMUNITY_BADGE",
        payload: [badgeData],
      });
    })
    .catch((error) => {
      console.error("Error fetching last badge:", error);
    });
};
